import { ErrorMessages } from "../../types/fieldTypes";

export interface FormFieldErrorContainerProps {
  errorMessages: ErrorMessages;
}

/**Primary Container for field error display*/
export const FormFieldErrorContainer: React.FC<
  FormFieldErrorContainerProps
> = ({ errorMessages }) => {
  return (
    <div className="error-message-container">
      {errorMessages
        .filter((x) => typeof x === "string")
        .map((errorMessage, idx) => (
          <p key={idx} className="error-message">
            {errorMessage}
          </p>
        ))}
    </div>
  );
};
